import { type JSX } from 'react';

import { Button } from 'Components/Buttons/Buttons';
import { Modal } from 'Components/Modal/Modal';
import { ICON_CLOSE, ICON_SAVE } from 'Config/Icons';
import { DueDiligenceControl } from 'Models/DueDiligence';
import { UploadedFile } from 'Models/Files';
import { DueDiligenceModule } from 'Models/ProductModule';
import { TprmOrUcrmDueDiligenceAssessment } from 'Models/UcrmTprm';
import { AssessmentFileReuseSelector, useAssessmentFileReuseSelection } from 'Pages/DueDiligenceAssessment/Components/AssessmentFileReuseSelector/AssessmentFileReuseSelector';

export interface ManageControlFilesModalProps {
    existingPendingFiles: File[];
    hideModal: () => void;
    initialControl: DueDiligenceControl;
    initialSelectedPendingFiles: File[];
    lastSavedAssessment: TprmOrUcrmDueDiligenceAssessment;
    module: DueDiligenceModule;
    onSave: (newPendingFiles: File[], selectedPendingFiles: File[], selectedUploadedFiles: UploadedFile[]) => void;
}

/** Used for due diligence assessments. Allows users to select files that have already been uploaded elsewhere--by internal users or third-party users--or to drop in new, reusable files. */
export const ManageControlFilesModal = (props: ManageControlFilesModalProps): JSX.Element => {
    const selection = useAssessmentFileReuseSelection({
        assessment: props.lastSavedAssessment,
        initialSelectedUploadedFiles: props.initialControl.control_assessment_human.files,
        existingPendingFiles: props.existingPendingFiles,
        initialSelectedPendingFiles: props.initialSelectedPendingFiles,
    });

    return (
        <Modal open header={`Manage Files for ${props.initialControl.name}`} subHeader={'Files that have already been added are available for reuse, or new files can be added in the dotted area.'}>
            <AssessmentFileReuseSelector internalFileCheckboxes={selection.internalFileCheckboxes} module={props.module} questionFileCheckboxes={selection.questionFileCheckboxes} onDropFiles={selection.onDropFiles} />

            <div className="modalFormButtonContainer">
                <Button variant="secondary" onClick={props.hideModal} fontAwesomeImage={ICON_CLOSE}>
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    onClick={() => {
                        props.onSave(selection.newPendingFiles, selection.selectedPendingFiles, selection.selectedUploadedFiles);
                        props.hideModal();
                    }}
                    fontAwesomeImage={ICON_SAVE}
                >
                    Save
                </Button>
            </div>
        </Modal>
    );
};
